import { useSelector } from 'react-redux';
import isBasketMetaSaveCompleteSuccessfulSelector from '/business/shared/state/selectors/application/update_syncing/isBasketMetaSaveCompleteSuccessfulSelector';
import usePrevious from '/business/shared/hooks/usePrevious';

export default function useGetWasMetaSaveSuccessful() {
  const wasSaveSuccessful = useSelector(isBasketMetaSaveCompleteSuccessfulSelector);
  const previousWasSave = usePrevious(wasSaveSuccessful);
  return previousWasSave === false && wasSaveSuccessful;
}
